import React from 'react';
import styles from './SectionCard.module.css';

// The white card chrome each org settings panel (Members, Folders, Jira,
// Assignees) sits in: a title row with an optional trailing action, then
// whatever body content is passed.
const SectionCard = ({title, action, children}) => (
    <section className={styles.card}>
        <div className={styles.header}>
            <h2 className={styles.title}>{title}</h2>
            {action}
        </div>
        {children}
    </section>
);

export default SectionCard;
